<div class="tl-wrap">

  <!-- KPI strip (hafalan) -->
  <div class="tl-kpis" *ngIf="kpi">
    <div class="tl-card tl-kpi">
      <span class="tl-label">Target Hafalan</span>
      <span class="tl-num">{{formatNumber(kpi.targets_total)}}</span>
      <span class="tl-kpi-foot">{{formatNumber(kpi.targets_users)}} pengguna &middot; {{formatNumber(kpi.targets_created_7d)}} dibuat 7 hari terakhir</span>
    </div>
    <div class="tl-card tl-kpi">
      <span class="tl-label">Target Selesai</span>
      <span class="tl-num">{{formatNumber(kpi.targets_complete)}}<span class="tl-num-of">/{{formatNumber(kpi.targets_total)}}</span></span>
      <span class="tl-kpi-foot">
        <span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="completePct()"></span></span>
        {{completePct()}}% &middot; {{formatNumber(kpi.targets_ongoing)}} berjalan &middot; <span [class.tl-warn]="kpi.targets_overdue">{{formatNumber(kpi.targets_overdue)}} lewat tenggat</span>
      </span>
    </div>
    <div class="tl-card tl-kpi">
      <span class="tl-label">Ayat Dihafal</span>
      <span class="tl-num">{{formatNumber(kpi.ayat_hafal)}}</span>
      <span class="tl-kpi-foot">oleh {{formatNumber(kpi.users_with_progress)}} pengguna &middot; dari 6.236 ayat</span>
    </div>
    <div class="tl-card tl-kpi">
      <span class="tl-label">Aktivitas 7 Hari</span>
      <span class="tl-num">{{formatNumber(kpi.ayat_7d)}}<span class="tl-num-of"> ayat</span></span>
      <span class="tl-kpi-foot">ditandai hafal oleh {{formatNumber(kpi.users_7d)}} pengguna</span>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="vl-toolbar">
        <div class="tl-seg" role="tablist" aria-label="Tampilan">
          <button type="button" role="tab" [class.on]="isView == 'users'" (click)="setView('users')">Pengguna</button>
          <button type="button" role="tab" [class.on]="isView == 'targets'" (click)="setView('targets')">Target</button>
          <button type="button" role="tab" [class.on]="isView == 'activity'" (click)="setView('activity')">Aktivitas</button>
        </div>

        <ng-container *ngIf="isView == 'targets'">
          <input class="vl-input" type="search" placeholder="Cari nama, judul, atau surat&hellip;"
                 aria-label="Cari hafalan" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter status" (change)="isStatus = $event.target.value; applyFilter()">
            <option value="">Semua status</option>
            <option value="ongoing">Berjalan</option>
            <option value="complete">Selesai</option>
            <option value="overdue">Lewat tenggat</option>
          </select>
          <select class="vl-select" aria-label="Filter mode pengulangan" (change)="isMode = $event.target.value; applyFilter()">
            <option value="">Semua mode</option>
            <option value="1">Nafas</option>
            <option value="0">Potongan</option>
          </select>
          <select class="vl-select" aria-label="Urutkan" (change)="isSort = $event.target.value; applyFilter()">
            <option value="newest">Terbaru</option>
            <option value="progress">Progres tertinggi</option>
            <option value="deadline">Tenggat terdekat</option>
            <option value="activity">Aktivitas terakhir</option>
          </select>
        </ng-container>

        <ng-container *ngIf="isView == 'users'">
          <input class="vl-input" type="search" placeholder="Cari nama atau email pengguna&hellip;"
                 aria-label="Cari pengguna" [value]="usersKeyword"
                 (input)="onUsersKeywordInput($event.target.value)" (keyup.enter)="applyUsersFilter()">
          <select class="vl-select" aria-label="Urutkan" (change)="usersSort = $event.target.value; applyUsersFilter()">
            <option value="ayat">Ayat terbanyak</option>
            <option value="targets">Target terbanyak</option>
            <option value="activity">Aktivitas terakhir</option>
          </select>
        </ng-container>

        <ng-container *ngIf="isView == 'activity'">
          <input class="vl-input" type="search" placeholder="Cari nama atau surat&hellip;"
                 aria-label="Cari aktivitas" [value]="actKeyword"
                 (input)="onActKeywordInput($event.target.value)" (keyup.enter)="applyActFilter()">
          <select class="vl-select" aria-label="Rentang waktu" [value]="actDays" (change)="actDays = $event.target.value; applyActFilter()">
            <option value="7">7 hari terakhir</option>
            <option value="30">30 hari terakhir</option>
            <option value="90">90 hari terakhir</option>
            <option value="">Semua waktu</option>
          </select>
        </ng-container>
        <div class="vl-spacer"></div>
        <span class="tl-readonly" title="Halaman ini hanya untuk memantau"><i class="fa fa-eye"></i> Hanya lihat</span>
      </div>

      <!-- ===== USERS ===== -->
      <div class="vl-card" *ngIf="isView == 'users'">
        <div class="vl-loading" *ngIf="usersLoading"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
        <div class="vl-scroll">
        <table class="vl-table">
          <thead>
          <tr>
            <th class="vl-num">No</th>
            <th>Pengguna</th>
            <th class="text-center">Ayat Dihafal</th>
            <th class="text-center">Target</th>
            <th style="width: 18%">Target Selesai</th>
            <th>Mulai Menghafal</th>
            <th>Aktivitas Terakhir</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let u of users; let i = index" class="vl-row tl-rowlink" [class.vl-alt]="i % 2 == 1" (click)="openUser(u)">
            <th class="vl-num">{{rangeFrom(usersPage, usersTotal) + i}}</th>
            <td>
              <div class="tl-ident">
                <img [src]="u.photoUrl || 'assets/images/no_avatar.webp'" alt="" class="tl-avatar-md" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                <div class="tl-ident-text">
                  <span class="vl-name" [innerHTML]="highlight(u.nameVw, usersKeyword)"></span>
                  <span class="tl-desc" *ngIf="u.email" [innerHTML]="highlight(u.email, usersKeyword)"></span>
                </div>
              </div>
            </td>
            <td class="text-center"><span class="tl-count">{{formatNumber(u.ayat_hafal)}}</span></td>
            <td class="text-center">{{formatNumber(u.targets_total)}}<div class="vl-small tl-warn" *ngIf="u.targets_overdue">{{formatNumber(u.targets_overdue)}} lewat tenggat</div></td>
            <td>
              <div class="tl-today" *ngIf="u.targets_total"><span class="tl-bar wide"><span class="tl-bar-fill" [style.width.%]="u.completePct"></span></span><span class="tl-pct">{{u.targets_complete}}/{{u.targets_total}}</span></div>
              <span class="vl-muted vl-small" *ngIf="!u.targets_total">Tanpa target &middot; tandai hafalan</span>
            </td>
            <td class="vl-muted">{{u.firstTargetVw}}</td>
            <td><span [title]="u.lastProgressFull">{{u.lastProgressVw}}</span></td>
          </tr>
          <tr *ngIf="!users.length && !usersLoading"><td colspan="7" class="vl-empty">Tidak ada pengguna yang cocok</td></tr>
          </tbody>
        </table>
        </div>
        <div class="vl-foot">
          <span class="vl-summary">Menampilkan <b>{{formatNumber(rangeFrom(usersPage, usersTotal))}}&ndash;{{formatNumber(rangeTo(usersPage, users.length))}}</b> dari <b>{{formatNumber(usersTotal)}}</b> pengguna</span>
          <div class="vl-spacer"></div>
          <nav class="vl-pager" aria-label="Navigasi halaman pengguna">
            <button type="button" class="vl-page" [disabled]="usersPage == 1" (click)="goUsersPage(usersPage - 1)">&lsaquo;</button>
            <ng-container *ngFor="let p of usersPages">
              <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
              <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == usersPage" (click)="goUsersPage(p)">{{p}}</button>
            </ng-container>
            <button type="button" class="vl-page" [disabled]="usersPage == pagesOf(usersTotal)" (click)="goUsersPage(usersPage + 1)">&rsaquo;</button>
          </nav>
        </div>
      </div>

      <!-- ===== TARGETS ===== -->
      <div class="vl-card" *ngIf="isView == 'targets'">
        <div class="vl-loading" *ngIf="isTableLoading"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
        <div class="vl-scroll">
        <table class="vl-table">
          <thead>
          <tr>
            <th class="vl-num">No</th>
            <th>Pengguna</th>
            <th>Target</th>
            <th>Mode</th>
            <th style="width: 18%">Progres</th>
            <th>Tenggat</th>
            <th>Aktivitas Terakhir</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let v of isData; let i = index" class="vl-row tl-rowlink" [class.vl-alt]="i % 2 == 1" (click)="openDetail(v)">
            <th class="vl-num">{{rowNo(i)}}</th>
            <td>
              <div class="tl-ident">
                <img [src]="v.userPhotoUrl || 'assets/images/no_avatar.webp'" alt="" class="tl-avatar-md" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                <div class="tl-ident-text">
                  <span class="vl-name" [innerHTML]="highlight(v.userName)"></span>
                  <span class="tl-desc" *ngIf="v.user_email" [innerHTML]="highlight(v.user_email)"></span>
                </div>
              </div>
            </td>
            <td>
              <div class="tl-ident-text">
                <span class="vl-name" [innerHTML]="highlight(v.title)"></span>
                <span class="tl-desc" [innerHTML]="highlight(v.range_text)"></span>
              </div>
            </td>
            <td>
              <span *ngIf="v.mode == 1" class="vl-tag nafas">Nafas</span>
              <span *ngIf="v.mode == 0" class="vl-tag potongan">Potongan</span>
              <div class="vl-muted vl-small">{{formatNumber(v.repeat_count)}}&times; ulang<ng-container *ngIf="v.auto_play_enabled"> &middot; auto {{v.auto_play_time}}</ng-container></div>
            </td>
            <td>
              <div class="tl-today">
                <span class="tl-bar wide"><span class="tl-bar-fill" [class.done]="v.is_complete" [style.width.%]="v.pct"></span></span>
                <span class="tl-pct">{{v.pct}}%</span>
              </div>
              <div class="vl-muted vl-small">{{formatNumber(v.hafal_count)}}/{{formatNumber(v.total_ayat)}} ayat</div>
            </td>
            <td>
              <span>{{v.targetVw || '—'}}</span>
              <div class="vl-small" [class.vl-muted]="v.status != 'overdue'" [class.tl-warn]="v.status == 'overdue'">{{v.deadlineVw}}</div>
            </td>
            <td><span [title]="v.lastProgressFull">{{v.lastProgressVw}}</span></td>
            <td>
              <span class="vl-pill" [class.on]="v.status == 'complete'" [class.wait]="v.status == 'ongoing'" [class.del]="v.status == 'overdue'">
                <span class="vl-dot"></span>{{statusLabel(v.status)}}</span>
            </td>
          </tr>
          <tr *ngIf="!isData.length && !isTableLoading"><td colspan="8" class="vl-empty">Tidak ada target yang cocok</td></tr>
          </tbody>
        </table>
        </div>
        <div class="vl-foot">
          <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> target</span>
          <div class="vl-spacer"></div>
          <nav class="vl-pager" aria-label="Navigasi halaman">
            <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
            <ng-container *ngFor="let p of isPages">
              <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
              <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage" (click)="goToPage(p)">{{p}}</button>
            </ng-container>
            <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
          </nav>
        </div>
      </div>

      <!-- ===== ACTIVITY ===== -->
      <div class="vl-card" *ngIf="isView == 'activity'">
        <div class="vl-loading" *ngIf="actLoading"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
        <ul class="tl-feed">
          <li *ngFor="let a of act" class="tl-feed-row">
            <img [src]="a.userPhotoUrl || 'assets/images/no_avatar.webp'" alt="" class="tl-avatar-md" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
            <div class="tl-feed-body">
              <div class="tl-feed-text"><b [innerHTML]="highlight(a.userName, actKeyword)"></b> menandai hafal <b [innerHTML]="highlight(a.surahName, actKeyword)"></b> {{a.rangeVw}}</div>
              <div class="tl-feed-meta"><span class="vl-tag kind">{{formatNumber(a.ayat_count)}} ayat</span><span>{{a.dayVw}}</span></div>
            </div>
            <time class="tl-feed-time" [title]="a.timeFull">{{a.timeVw}}</time>
          </li>
          <li *ngIf="!act.length && !actLoading" class="vl-empty">Tidak ada aktivitas pada rentang ini</li>
        </ul>
        <div class="vl-foot">
          <span class="vl-summary">Menampilkan <b>{{formatNumber(rangeFrom(actPage, actTotal))}}&ndash;{{formatNumber(rangeTo(actPage, act.length))}}</b> dari <b>{{formatNumber(actTotal)}}</b> aktivitas</span>
          <div class="vl-spacer"></div>
          <nav class="vl-pager" aria-label="Navigasi halaman aktivitas">
            <button type="button" class="vl-page" [disabled]="actPage == 1" (click)="goActPage(actPage - 1)">&lsaquo;</button>
            <ng-container *ngFor="let p of actPages">
              <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
              <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == actPage" (click)="goActPage(p)">{{p}}</button>
            </ng-container>
            <button type="button" class="vl-page" [disabled]="actPage == pagesOf(actTotal)" (click)="goActPage(actPage + 1)">&rsaquo;</button>
          </nav>
        </div>
      </div>

    </div>
  </div>
</div>
